/**
 * @GENERATED from Figma node 3638:51922
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const WorkdayBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#005CB9"
      d="M17.226 23c.354 0 .544-.167.625-.418l2.637-10.385c.082-.362-.136-.557-.435-.557h-1.276c-.326 0-.598.14-.652.445l-1.604 6.422c-.163.808-.272.927-.38 1.706-.11-.807-.218-.898-.436-1.706l-1.637-6.394c-.082-.306-.354-.473-.68-.473h-2.056c-.327 0-.571.14-.653.445l-1.77 6.422c-.217.808-.326.927-.462 1.706-.082-.807-.136-.898-.326-1.734l-1.58-6.366c-.082-.362-.272-.473-.625-.473H4.558c-.3 0-.517.195-.435.557l2.773 10.385c.081.334.244.418.57.418h2.012c.354 0 .571-.167.626-.418l1.85-7.211c.19-.696.232-.851.38-1.463.172.612.19.739.38 1.463l1.957 7.211c.081.334.244.418.57.418z"
    />
    <path
      fill="#F38B00"
      fillRule="evenodd"
      d="M12.266 3.24a6.32 6.32 0 0 0-6.07 4.553 1.12 1.12 0 0 1-2.151-.626 8.563 8.563 0 0 1 16.441 0 1.12 1.12 0 0 1-2.15.626 6.32 6.32 0 0 0-6.07-4.553"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(WorkdayBright);
export { ForwardRef as WorkdayBright };
